<template>
  <div class="relative p-6 w-full max-w-lg bg-white rounded-lg shadow-lg">
    <div class="text-lg font-bold text-black">Submit Feedback</div>

    <!-- Feedback form -->
    <form @submit.prevent="submitFeedback">
      <textarea
        v-model="feedbackMessage"
        class="p-2 mt-4 w-full text-black border"
        rows="4"
        placeholder="Write your feedback here..."></textarea>

      <div class="flex justify-between mt-4">
        <button
          type="button"
          class="py-2 px-4 bg-gray-300 rounded-sm"
          @click="closeModal()">
          Cancel
        </button>
        <button
          type="submit"
          class="py-2 px-4 text-white bg-blue-500 rounded-sm">
          Submit
        </button>
      </div>
    </form>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue'

const emit = defineEmits(['close'])

const closeModal = () => {
  feedbackMessage.value = ''
  emit('close')
}

// Feedback message state
const feedbackMessage = ref('')

// Slack webhook URL
const SLACK_WEBHOOK_URL =
  'https://hooks.slack.com/services/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'

// Function to send feedback to Slack
const sendFeedbackToSlack = async (message) => {
  try {
    const response = await fetch(SLACK_WEBHOOK_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        text: `New feedback submitted: ${message}`
      })
    })

    return response
  } catch (error) {
    console.error('Error sending feedback to Slack:', error)
    return { ok: false }
  }
}

// Function to submit feedback
const submitFeedback = async () => {
  if (feedbackMessage.value.trim() === '') {
    alert('Please enter your feedback!')
    return
  }

  // Send feedback to Slack
  const slackResponse = await sendFeedbackToSlack(feedbackMessage.value)

  if (slackResponse.ok) {
    alert('Feedback sent successfully!')
    closeModal()
  } else {
    alert('Failed to send feedback.')
  }
}
</script>
